// src/components/Header.jsx
import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../Redux/actions/userActions.js";
import { useNavigate, Link } from "react-router-dom";
import "./HeaderFooter.css"; // 👈 Add shared style file

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const renderLinks = () => {
    if (!userInfo) {
      return (
        <>
          <Nav.Link as={Link} to="/login" className="nav-link-custom">
            Login
          </Nav.Link>
          <Nav.Link as={Link} to="/register" className="nav-link-custom">
            Register
          </Nav.Link>
        </>
      );
    }

    const role = userInfo.user.role;

    switch (role) {
      case "admin":
        return (
          <>
            <Nav.Link
              as={Link}
              to="/admin/dashboard"
              className="nav-link-custom"
            >
              Dashboard
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/admin/appointments"
              className="nav-link-custom"
            >
              Appointments
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/admin/departments"
              className="nav-link-custom"
            >
              Departments
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/admin/medicines"
              className="nav-link-custom"
            >
              Medicines
            </Nav.Link>
            <Nav.Link as={Link} to="/admin/doctors" className="nav-link-custom">
              Doctors
            </Nav.Link>
            <Nav.Link onClick={handleLogout} className="nav-link-custom">
              Logout
            </Nav.Link>
          </>
        );
      case "doctor":
        return (
          <>
            <Nav.Link
              as={Link}
              to="/doctor/dashboard"
              className="nav-link-custom"
            >
              Dashboard
            </Nav.Link>
            <Nav.Link onClick={handleLogout} className="nav-link-custom">
              Logout
            </Nav.Link>
          </>
        );
      case "pharmacist":
        return (
          <>
            <Nav.Link as={Link} to="/counter" className="nav-link-custom">
              Pharmacist
            </Nav.Link>
            <Nav.Link onClick={handleLogout} className="nav-link-custom">
              Logout
            </Nav.Link>
          </>
        );
      case "receptionist":
        return (
          <>
            <Nav.Link
              as={Link}
              to="/receptionist/walk-in"
              className="nav-link-custom"
            >
              Walk-In Appointment
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/receptionist/appointments"
              className="nav-link-custom"
            >
              Manage Appointments
            </Nav.Link>
            <Nav.Link onClick={handleLogout} className="nav-link-custom">
              Logout
            </Nav.Link>
          </>
        );
      default:
        return (
          <>
            <Nav.Link
              as={Link}
              to="/patient/appointments"
              className="nav-link-custom"
            >
              Book Appointment
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/patient/myappointments"
              className="nav-link-custom"
            >
              My Appointments
            </Nav.Link>
            {/* <Nav.Link
              as={Link}
              to="/patient/medicine"
              className="nav-link-custom"
            >
              Medicines
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/patient/history"
              className="nav-link-custom"
            >
              History
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/patient/labreports"
              className="nav-link-custom"
            >
              Lab Reports
            </Nav.Link> */}
            <Nav.Link onClick={handleLogout} className="nav-link-custom">
              Logout
            </Nav.Link>
          </>
        );
    }
  };

  return (
    <Navbar expand="lg" className="custom-navbar shadow-sm py-3" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/" className="fw-bold hospital-brand">
          🩺 Zainab Medical & Children Care Centre
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          <Nav>{renderLinks()}</Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
